import { __awaiter } from '../_virtual/_tslib.js';
import { useState, useEffect } from 'react';

function useGetBlobUrlFromUrl(url = "") {
    const [blobUrl, setBlobUrl] = useState("");
    useEffect(() => {
        (() => __awaiter(this, void 0, void 0, function* () {
            if (url) {
                try {
                    const response = yield fetch(url);
                    const blob = yield response.blob();
                    const fileURL = URL.createObjectURL(blob);
                    setBlobUrl(fileURL);
                }
                catch (error) {
                    console.error("Failed to fetch blob:", error);
                }
            }
        }))();
    }, [url]);
    return { blobUrl };
}

export { useGetBlobUrlFromUrl };
//# sourceMappingURL=useGetBlobUrlFromUrl.js.map
